import { useSelector } from 'react-redux'
import { COUNTRY } from '../const/constants'
import { useAppContext } from '../context/AppContext'
import useRequests from '../hooks/useRequests'
import Button from './Button'

interface Props {
  storeForm: string
  label: string
}

const ProspectoButton = ({ storeForm, label }: Props) => {
  const { handleSubmitProspectos } = useRequests(storeForm)
  const { settings }: any = useAppContext()

  const { documento, ...fields } = useSelector((state: any) => state[storeForm])
  const validity = () => {
    if (settings.country === COUNTRY.AR && fields.negocio === '1')
      return Object.values(fields).some((value: any) => !value)
    else return Object.values({ ...fields, documento }).some((value: any) => !value)
  }
  return (
    <Button
      id="save-referred"
      className="submit-button"
      label={label}
      validity={validity()}
      handleSubmit={handleSubmitProspectos}
    />
  )
}

export default ProspectoButton
